/**
 * Footer - View component for application footer
 * Pure presentation component with no business logic
 */

import React from 'react';
import GitHubIcon from './icons/GitHubIcon';

export default function Footer() {
  return (
    <footer className="app-footer" aria-label="Footer">
      <div style={styles.footerContent}>
        <a
          href="https://github.com/Sixstringcal/FMC-Grader"
          target="_blank"
          rel="noopener noreferrer"
          className="github-link"
        >
          <GitHubIcon />
          <span>FMC-Grader on GitHub</span>
        </a>
        <a href="/privacy-policy" className="privacy-link">
          Privacy Policy
        </a>
      </div>
    </footer>
  );
}

const styles = {
  footerContent: {
    display: 'flex',
    gap: 12,
    alignItems: 'center',
    justifyContent: 'center'
  }
};
